{
  "last_updated": "Yéegal bu mujj : 22 Mars 2026",
  "company": {
    "name": "CIEDA (Compagnie Import Export & Distribution Africaine)",
    "brand": "Djayma",
    "address": "Hann Mariste II, Dakar, Senegaal",
    "phone": "+221 76 604 22 74",
    "email": "contact@cieda.sn",
    "website": "djayma.com"
  },
  "cgv": {
    "title": "Cëru Jënd yi",
    "subtitle": "Yoonu jënd ci djayma.com",
    "preamble": "Cëru Jënd yi (CGV) moo sàcc jënd yépp ci plateforme Djayma, bu CIEDA sos. Jënd bu nekk moo tekki nangu cëru yi.",
    "s1_title": "1. Ñi kontara bi dal",
    "s1_body": "Kontara bi dal na CIEDA (Compagnie Import Export & Distribution Africaine), bu bindu ci Senegaal, bu siège bi nekk ci Hann Mariste II, Dakar — ci pàtte « Djayma » walla « jaaykat bi » — ak nit ku baax walla jumtukaay bu jënd ci plateforme djayma.com, ci pàtte « kiliyaan bi ».",
    "s2_title": "2. Produwe ak am-am",
    "s2_body": "Produwe yu ñu jaay moo di yi marka CIEDA : Countre Dairy (meew), Yousra (mayonnez ak ceeb), Florida (konseerw), ak KamaX/KamiX (setal ak sàffu). Jox yi dañu nekk ci stock bi am. Bu produwe amul ginnaaw komand bi, dinu la xibaar ci gaaw te mën nga tànn enter fey delloo walla produwe bu bees.",
    "s3_title": "3. Njëg yi",
    "s3_body": "Njëg yépp ci Djayma dañu ko wax ci FCFA, ak taxe yépp ci biir (TVA 18%). Njëg indil bi dañu ko won ci yoonu komand bi te soppiku ci zone indil bi. Djayma mën na soppi njëg yi ci kaw kàngam. Njëg yu jëf moo di yi nekk ci waxtu komand bi.",
    "s4_title": "4. Yoonu komand bi",
    "s4_step1": "Tànn produwe yi te yokk ci paañe bi",
    "s4_step2": "Xool paañe bi te duggal adres indil bi",
    "s4_step3": "Tànn yoonu fey bi",
    "s4_step4": "Dëggal komand bi te fey",
    "s4_step5": "Jot dëggal ci SMS walla email",
    "s4_step6": "Indil ak jot produwe yi",
    "s4_note": "Djayma mën na bañ komand bu nekk ci daleel bu baax (fraude, adres bu mënul dëkk, komand bu mag lool, etc.).",
    "s5_title": "5. Yoonu fey yi",
    "s5_body": "Djayma nangu na yoonu fey yii :",
    "s5_wave": "Wave — fey ci telefon bu gaaw",
    "s5_om": "Orange Money — fey ci telefon ak Orange",
    "s5_cod": "Fey ci jëlëg (Cash on Delivery) — am na ci yeneen zone yi",
    "s5_security": "Fey yu digital dañu ko suturlu ak operateur yi nangu. Djayma dëncuwul données fey bu am solo.",
    "s6_title": "6. Zone ak waxtu indil yi",
    "s6_body": "Djayma indil na ci zone yii :",
    "s6_zones": ["Dakar ak tuur tuur bi (Parcelles Assainies, Hann Mariste, etc.)", "Kaolack", "Ndar", "Fatig", "Cees-Mbuur", "Jurbel-Tuubaa"],
    "s6_delays": "Waxtu indil yi dañu ko won ci komand bi te soppiku ci zone bi. Djayma dina jëf li mën jëf ngir topp waxtu yi, waaye mënuñu fajal ci cas de force majeure.",
    "s7_title": "7. Fetal moom ak risque",
    "s7_body": "Fetal moom ci produwe yi moo def ci waxtu fey bu mat. Risque moo fetal ci indil, bi ñu jox produwe yi kiliyaan bi walla ku ko tànn.",
    "s8_title": "8. Sañ-sañ retuur",
    "s8_body": "Ci daleel sunu Politig Retuur, kiliyaan bi am na 14 fan ginnaaw bés indil bi ngir ñaane retuur produwe bu baaxul walla bu am njuumte. Ci lëkk yu gaaw jeex, retuur nangu na rekk bu am njuumte ci indil bi.",
    "s9_title": "9. Responsabilité",
    "s9_body": "Djayma jàngël ci indil produwe yu baax ak li ñu tekki ci plateforme bi. Responsabilité bi mujj na ci tollu komand bi. Djayma mënul am jaamu ci njuumte yu am ci ginnaaw, perte walla mbir mu nekk ci jëfandikoo produwe yi.",
    "s10_title": "10. Données personnelles",
    "s10_body": "Jëfandikoo données personnelles yi dañu ko sàcc ci sunu Politig Suturlu, am na ci djayma.com. Ci daleel Loi sénégalaise n° 2008-12, kiliyaan bi am na sañ-sañ ci jàng, sàcc ak jéeral données moom.",
    "s11_title": "11. Droit ak tribunal",
    "s11_body": "CGV yi dañu ko sàcc ci droit sénégalais. Mbir bu nekk ci biral yi walla jëf yi dinu ko jox tribunal yi ci Dakar, Senegaal.",
    "s12_title": "12. Soppi",
    "s12_body": "Djayma mën na soppi CGV yi ci kaw kàngam. Soppi yi dina jëf bi ñu ko def ci plateforme bi. Kiliyaan bi dafna xoolal xàtt bii regu.",
    "contact_title": "Jokkoo",
    "contact_body": "Laaj bu nekk ci CGV yi, jokkoo ak sunu ekip :"
  },
  "privacy": {
    "title": "Politig Suturlu",
    "subtitle": "Suturlu données personnelles ci daleel loi sénégalaise",
    "preamble": "Djayma, marka CIEDA, jàngël na ci suturlu mbir yu jëfandikookaay yi ci daleel Loi n° 2008-12 du 25 janvier 2008 ci suturlu données personnelles ci Senegaal.",
    "s1_title": "1. Ku sàcc jëfandikoo bi",
    "s1_body": "Ku sàcc jëfandikoo données personnelles yi moo di CIEDA (Compagnie Import Export & Distribution Africaine), bu siège bi nekk ci Hann Mariste II, Dakar, Senegaal.",
    "s2_title": "2. Cadre juridique",
    "s2_body": "Jëfandikoo données personnelles yi dañu ko sàcc ci Loi n° 2008-12 du 25 janvier 2008 ci suturlu données personnelles ci Senegaal, ak décisions Commission des Données Personnelles (CDP) Senegaal.",
    "s3_title": "3. Données yu ñu jële",
    "s3_intro": "Ñu jële données yii ci biir sunu sëriñ yi :",
    "s3_identity": "Données identification : tur, sant, email, nimero telefon",
    "s3_delivery": "Données indil : adres, zone indil, GPS (su la nangu)",
    "s3_order": "Données komand : liggéeyu komand yi, tollu yi ci FCFA, yoonu fey yu tànn",
    "s3_navigation": "Données navigation : xàtt yi nga seet, jëf yi nga def (su nangu cookies analytiques)",
    "s4_title": "4. Li tax ñuy jëfandikoo",
    "s4_items": [
      "Saytu, sàcc ak topp komand yi",
      "Indil produwe yu komandé",
      "Sos ak sàcc kont kiliyaan bi",
      "Xibaar ci komand bi ci SMS walla email",
      "Saytu ñaane retuur ak fey delloo yi",
      "Yokki sëriñ yi ak expérience jëfandikoo bi",
      "Statistik bu suturlu ci jëfandikoo plateforme bi"
    ],
    "s5_title": "5. Cookies ak outils analytiques",
    "s5_posthog": "Ñu jëfandikoo PostHog ngir seet naka ñuy jëfandikoo plateforme bi. Cookies analytiques nangu nañu ko rekk bu ngay nangu ci bannière cookies bi.",
    "s5_sentry": "Ñu jëfandikoo Sentry ngir gis njuumte teknik yi. Sentry jëlewul données personnelles.",
    "s5_manage": "Mën nga bañ kàngam ci parameetar navigateur bi.",
    "s6_title": "6. Féetal données yi",
    "s6_intro": "Données personnelles yi dukku jaay. Mën ñu ko féetal ak :",
    "s6_payment": "Prestataires fey (Wave, Orange Money) — ngir saytu fey yi",
    "s6_delivery": "Partenaires indil — ngir yóbbu komand yi",
    "s6_infra": "Prestataires infrastructure (Vercel, Supabase, Sentry, PostHog) — ngir jëfandikoo teknik plateforme bi",
    "s7_title": "7. Waxtu dënc",
    "s7_account": "Données kont : ñu ko dënc bi kont bi aktif, ci kanam 3 at",
    "s7_orders": "Données komand : 5 at (obligation légale comptable)",
    "s7_navigation": "Données navigation : 13 weer bu gën a bari",
    "s7_sessions": "Données sessions (replays) : 30 fan bu gën a bari",
    "s8_title": "8. Sa sañ-sañ yi (APDP — Loi 2008-12)",
    "s8_intro": "Ci daleel Loi 2008-12, am nga sañ-sañ yii :",
    "s8_access": "Sañ-sañ jàng : jot kopi données personnelles yi Djayma sàcci",
    "s8_rectification": "Sañ-sañ sàcc : sàcc données yu njuumte walla yu mat wul",
    "s8_deletion": "Sañ-sañ jéeral : ñaane jéeral données yi (ci daleel obligation conservation yi)",
    "s8_opposition": "Sañ-sañ bañ : bañ jëfandikoo données yi ci marketing",
    "s8_portability": "Sañ-sañ portabilité : jot données yi ci format bu strukturé",
    "s8_exercise": "Ngir jëfandikoo sañ-sañ yii, jokkoo ak DPO bi :",
    "s9_title": "9. Kaarange",
    "s9_body": "Ñu def mesures teknik ak organisasion ngir suturlu données yi : chiffrement TLS/HTTPS, contrôle accès RLS Supabase, hébergement bu suturlu, ak audit yi regu.",
    "s10_title": "10. Plaintif ci CDP",
    "s10_body": "Bu xalaatee sañ-sañ yi mënuñu ko sàcc, mën nga def plaintif ci Commission des Données Personnelles (CDP) Senegaal.",
    "s11_title": "11. Soppi",
    "s11_body": "Mën ñu soppi politig bii ci kaw kàngam. Bés bu mujj bu yéegal bi am na ci kaamu xàtt bii.",
    "dpo_label": "Délégué à la Protection des Données (DPO)"
  },
  "returns": {
    "title": "Politig Retuur",
    "subtitle": "Cëru ak yoonu retuur ak fey delloo",
    "preamble": "Ci Djayma, sa bëgg-bëgg moo gën. Bu neexul ci komand bi, ñu dina jëf li mën jëf ngir gis solution bu gaaw ak bu jub.",
    "s1_title": "1. Waxtu retuur bi",
    "s1_body": "Am nga 14 fan ginnaaw bés indil bi ngir ñaane retuur. Ginnaaw bés bii, amul ñaane retuur bu ñu nangu, sauf bu am njuumte bu nëbb.",
    "s1_note": "Ci lëkk yu gaaw jeex, retuur bi war na ñu signalee ci bés indil bi.",
    "s2_title": "2. Cëru éligibilité",
    "s2_intro": "Ngir mën delloo, produwe bi war na :",
    "s2_conditions": [
      "Nekk ci emballaas bi woon (ubbiwul ci lëkk yu njuumte amul)",
      "Am njuumte walla am-am bi ñu tekki ci ñaane bi",
      "Am nimero komand bi",
      "Jëfandikoo wees bu bari lool"
    ],
    "s2_excluded_title": "Produwe yu mënuñu delloo :",
    "s2_excluded": [
      "Lëkk yu ubbi walla yu ñu lekk ci (sauf njuumte bu am)",
      "Lëkk yu DLC bi jeex ginnaaw indil bi",
      "Produwe setal ak sàffu yu ubbi (sauf njuumte fabrication)",
      "Komand yu personnalisé"
    ],
    "s3_title": "3. Ngirte retuur yu nangu",
    "s3_items": [
      "Produwe bu yàqu walla bu njeex ci indil bi",
      "Produwe bu jeex ci indil bi",
      "Produwe bu baaxul — benn laa woon bëgg",
      "Produwe bu baaxul ak li ñu tekki ci site bi",
      "Soppi xel (ci daleel cëru éligibilité yi)"
    ],
    "s4_title": "4. Yoonu ñaane retuur",
    "s4_step1_title": "Etap 1 — Yonnee ñaane bi",
    "s4_step1_body": "Dugg ci sa kont Djayma, dem ci « Sama komand yi » ci kanam « Ñaane retuur ». Tànn produwe yi, wax ngirte bi te yokk nataal su mën.",
    "s4_step2_title": "Etap 2 — Saytu ñaane bi",
    "s4_step2_body": "Sunu ekip dina xool ñaane bi ci biir 48 waxtu. Dinga jot xibaar ci SMS walla email.",
    "s4_step3_title": "Etap 3 — Jële produwe bi",
    "s4_step3_body": "Bu ñu nangu ñaane bi, ñu dina jëfandikoo jële produwe bi ci sa adres indil bi, amul tax ci kaw.",
    "s4_step4_title": "Etap 4 — Fey delloo",
    "s4_step4_body": "Bu ñu jot produwe bi te xool ko, fey delloo bi dina am ci biir 3 ak 5 fan ci daleel yoonu fey bu tànn.",
    "s5_title": "5. Yoonu fey delloo yi",
    "s5_intro": "Mën nga tànn ci yoonu fey delloo yii :",
    "s5_original": "Yoonu fey bi woon — fey delloo ci kont Wave walla Orange Money bi nga jëfandikoo (waxtu : 3–5 fan)",
    "s5_wave": "Wave — wérsëg ci sa kont Wave (waxtu : 1–2 fan)",
    "s5_om": "Orange Money — wérsëg ci sa kont Orange Money (waxtu : 1–2 fan)",
    "s5_credit": "Kreedi bitik Djayma — kreedi bu am ci kaw ci sa kont ngir sa jënd bi ci topp",
    "s5_note": "Komand yu fey ci xaalis (fey ci jëlëg), fey delloo bi dina am ci Wave, Orange Money, walla kreedi bitik ci tànn kiliyaan bi.",
    "s6_title": "6. Produwe yu yàqu ci indil bi",
    "s6_body": "Bu gisee paket bi yàqu ci indil bi, waxal ci kanam livreur bi te jël nataal. Jokkoo ak service client bi ci 24 waxtu ci appli bi walla telefon ci +221 76 604 22 74. Fey delloo walla soppi intégral dina am amul tax.",
    "s7_title": "7. Jokkoo service retuur",
    "s7_body": "Laaj bu nekk ci retuur walla fey delloo bi, jokkoo ak sunu ekip :",
    "s7_hours": "Am na altine ak gaawu, 8h00 ak 20h00",
    "s7_whatsapp": "WhatsApp am na ngir topp yoonu sa retuur bi",
    "cta_text": "Pare nga ñaane retuur?",
    "cta_button": "Def ñaane retuur"
  }
}
